const softBreak = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        return (
            <span {...attributes}>
                <br />
                {children}
            </span>
        );
    },
    PreviewElement: ({}) => {
        return <br />;
    },
};

export default softBreak;
